import React, { useState, useEffect } from 'react';

// JST (Asia/Tokyo) 基準で YYYY-MM-DD 文字列を取得するヘルパー関数
const formatToJstDateString = (dateObj) => {
  if (!dateObj) return '';
  const date = dateObj.toDate ? dateObj.toDate() : (dateObj instanceof Date ? dateObj : new Date(dateObj));
  if (isNaN(date.getTime())) return '';
  const formatter = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  return formatter.format(date).replace(/\//g, '-');
};

function ReleaseNoteForm({ releaseNote, onSave, onCancel }) {
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');
  const [publishedAt, setPublishedAt] = useState(formatToJstDateString(new Date()));
  const [status, setStatus] = useState('draft');

  useEffect(() => {
    if (releaseNote) {
      setTitle(releaseNote.title || '');
      setBody(releaseNote.body || '');
      setPublishedAt(releaseNote.publishedAt ? formatToJstDateString(releaseNote.publishedAt) : '');
      setStatus(releaseNote.status || 'draft');
    } else {
      setTitle('');
      setBody('');
      setPublishedAt(formatToJstDateString(new Date()));
      setStatus('draft');
    }
  }, [releaseNote]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // JST 00:00:00 としてタイムスタンプを生成 (YYYY-MM-DDT00:00:00+09:00)
    const jstDate = publishedAt ? new Date(`${publishedAt}T00:00:00+09:00`) : new Date();
    onSave({
      id: releaseNote?.id,
      title,
      body,
      publishedAt: jstDate,
      status
    });
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">タイトル</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className="w-full border rounded px-3 py-2"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">本文</label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          className="w-full border rounded px-3 py-2 h-40"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">公開日</label>
        <input
          type="date"
          value={publishedAt}
          onChange={(e) => setPublishedAt(e.target.value)}
          className="w-full border rounded px-3 py-2"
          required
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2">公開状態</label>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="w-full border rounded px-3 py-2"
        >
          <option value="draft">下書き (Draft)</option>
          <option value="published">公開 (Published)</option>
        </select>
      </div>
      <div className="flex justify-end space-x-2">
        <button
          type="button"
          onClick={onCancel}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          キャンセル
        </button>
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          {releaseNote ? '更新' : '作成'}
        </button>
      </div>
    </form>
  );
}

export default ReleaseNoteForm;
